import { guideSteps } from '@/mocks/nav';

export default function GuideSection() {
  return (
    <section
      id="guide"
      className="scroll-mt-20 border-b border-background-200 bg-background-100 py-14 md:scroll-mt-24 md:py-20"
    >
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600 md:text-sm">
            <i className="ri-compass-3-line text-base" aria-hidden="true"></i>
            How It Works
          </p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">找瓜指南</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            四步就能定位到想要的入口，新手也能一分钟上手。
          </p>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:mt-10 md:gap-5">
          {guideSteps.map((item) => (
            <li
              key={item.step}
              className="relative flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-700">
                  <i className={item.icon} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-3xl font-black text-background-300">{item.step}</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}